function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import UnstyledButton from './UnstyledButton';
const LinkButton = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(UnstyledButton, _extends({
  ref: ref,
  variant: "link"
}, props)));
LinkButton.displayName = 'LinkButton';
export default LinkButton;